// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listOfEmployeesScreen {
  background-color: #f3f4f6;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
}
.listOfEmployeesScreen .header {
  margin: auto;
  display: flex;
  flex-direction: row;
}
.listOfEmployeesScreen .header .leftContainer {
  width: 20%;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
}
.listOfEmployeesScreen .header .notWorkingLeftContainer {
  width: 20%;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
  margin-top: 60px;
}
.listOfEmployeesScreen .header .rightContainer {
  width: 80%;
  display: flex;
  flex-direction: row;
  align-content: flex-end;
}
.listOfEmployeesScreen .header .rightContainer .textLabel {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #868686;
  margin-left: auto;
}
.listOfEmployeesScreen .header .rightContainer .button {
  align-items: center;
  gap: 10px;
  width: 169px;
  height: 50px;
  background: #ffffff;
  border: 1px solid #49ae9e;
  border-radius: 8px;
  color: #49ae9e;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  margin-left: 12px;
}
.listOfEmployeesScreen .detailCard {
  margin-top: 2%;
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
}
.listOfEmployeesScreen .detailCard .cardHeader {
  display: flex;
}
.listOfEmployeesScreen .detailCard .cardHeader .leftContainer {
  text-align: left;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}
.listOfEmployeesScreen .detailCard .cardHeader .rightContainer {
  margin-left: auto;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
}
.listOfEmployeesScreen .detailCard .tableContainer .nameCircle {
  background: #c1c1c1;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  color: white;
  font-weight: 700;
  font-size: 8px;
  line-height: 16px;
  text-align: center;
  padding-top: 4px;
  position: relative;
}
.listOfEmployeesScreen .detailCard .tableContainer .nameText {
  position: relative;
  top: 3px;
  padding-left: 10px;
}
.listOfEmployeesScreen .detailCard .tableContainer .actionButton {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #505054;
  border: 1px solid #e1e1e1;
  border-radius: 6px;
  padding: 8px;
  margin: auto;
  background-color: white;
}
.listOfEmployeesScreen .detailCard .tableContainer .disabledButton {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #505054;
  border-radius: 6px;
  padding: 8px;
  margin: auto;
  background-color: white;
  cursor: default;
}
.listOfEmployeesScreen .detailCard .tableContainer .stateCellContainer {
  display: flex;
  flex-direction: row;
}
.listOfEmployeesScreen .detailCard .tableContainer .stateCellContainer .stateIndicator {
  height: 6px;
  width: 6px;
  border-radius: 3px;
  margin-right: 10px;
  position: relative;
  top: 5px;
}
.listOfEmployeesScreen .detailCard .tableContainer .stateCellContainer .probation {
  position: relative;
  margin-left: 10px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  color: #49ae9e;
  padding: 0 5px;
  background: #e5f4f2;
  border-radius: 50px;
  text-align: center;
}
.listOfEmployeesScreen .detailCard .tableContainer .typeContainer {
  display: inline-block;
  padding: 2px 6px;
  background: #f9e0da;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
}
.listOfEmployeesScreen .detailCard .tableContainer .redType {
  background-color: #f9e0da;
  color: #874a3d;
}
.listOfEmployeesScreen .detailCard .tableContainer .blueType {
  background-color: #d5e5f3;
  color: #385b7d;
}
.listOfEmployeesScreen .detailCard .tableContainer .greenType {
  background-color: #d6eed9;
  color: #2b6132;
}
.listOfEmployeesScreen .detailCard .tableContainer table {
  border: none;
  margin-top: 24px;
  width: 100%;
  border-collapse: collapse;
}
.listOfEmployeesScreen .detailCard .tableContainer th {
  border: none;
  height: 48px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #505054;
  background: #f9fafb;
  border-top: 1px solid black;
  border-bottom: 1px solid #e9e9e9;
}
.listOfEmployeesScreen .detailCard .tableContainer th .flexibleColumns {
  display: flex;
  flex-direction: row;
  padding-left: 50px;
}
.listOfEmployeesScreen .detailCard .tableContainer th .flexibleColumnsNotWorking {
  display: flex;
  flex-direction: row;
  padding-left: 25px;
}
.listOfEmployeesScreen .detailCard .tableContainer th input {
  margin-right: 10px;
}
.listOfEmployeesScreen .detailCard .tableContainer td {
  height: 64px;
  border-bottom: 1px solid #e9e9e9;
}
.listOfEmployeesScreen .detailCard .tableContainer td input {
  position: relative;
  margin-right: 10px;
}
.listOfEmployeesScreen .detailCard .tableContainer td .flexibleColumns {
  display: flex;
  flex-direction: row;
  padding-left: 50px;
}
.listOfEmployeesScreen .detailCard .tableContainer td .flexibleColumnsNotWorking {
  display: flex;
  flex-direction: row;
  padding-left: 25px;
}

.deleteContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
.deleteContainer .delete {
  border: 1px solid red;
  color: red;
  border-radius: 8px;
  padding: 12px 48px;
}

.tooltip-row {
  margin-bottom: 2px;
}`, "",{"version":3,"sources":["webpack://./src/screens/listOfEmployees/ListOfEmployees.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,iCAAA;EACA,kBAAA;AACJ;AAAI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;AAER;AADQ;EACI,UAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAGZ;AADQ;EACI,UAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAGZ;AADQ;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAGZ;AADY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AAGhB;AAAY;EACI,mBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAEhB;AAEI;EACI,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AAAR;AAEQ;EACI,aAAA;AAAZ;AACY;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAChB;AACY;EACI,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AAChB;AAIY;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAFhB;AAKY;EACI,kBAAA;EACA,QAAA;EACA,kBAAA;AAHhB;AAMY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;AAJhB;AAOY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;AALhB;AAOY;EACI,aAAA;EAEA,mBAAA;AANhB;AAOgB;EACI,WAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AALpB;AAQgB;EACI,kBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AANpB;AASY;EACI,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAPhB;AASY;EACI,yBAAA;EACA,cAAA;AAPhB;AAUY;EACI,yBAAA;EACA,cAAA;AARhB;AAWY;EACI,yBAAA;EACA,cAAA;AAThB;AAYY;EACI,YAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;AAVhB;AAYY;EAWI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,2BAAA;EACA,gCAAA;AApBhB;AACgB;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AACpB;AACgB;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AACpB;AAYgB;EACI,kBAAA;AAVpB;AAaY;EACI,YAAA;EACA,gCAAA;AAXhB;AAYgB;EACI,kBAAA;EACA,kBAAA;AAVpB;AAagB;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAXpB;AAagB;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAXpB;;AAmBA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;AAhBA;AAkBI;EACI,qBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;AAhBR;;AAmBA;EACI,kBAAA;AAhBJ","sourcesContent":[".listOfEmployeesScreen {\n    background-color: #f3f4f6;\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    .header {\n        margin: auto;\n        display: flex;\n        flex-direction: row;\n        .leftContainer {\n            width: 20%;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            color: #333333;\n        }\n        .notWorkingLeftContainer {\n            width: 20%;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            color: #333333;\n            margin-top: 60px;\n        }\n        .rightContainer {\n            width: 80%;\n            display: flex;\n            flex-direction: row;\n            align-content: flex-end;\n\n            .textLabel {\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                display: flex;\n                align-items: center;\n                color: #868686;\n                margin-left: auto;\n            }\n\n            .button {\n                align-items: center;\n                gap: 10px;\n                width: 169px;\n                height: 50px;\n                background: #ffffff;\n                border: 1px solid #49ae9e;\n                border-radius: 8px;\n                color: #49ae9e;\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 22px;\n                margin-left: 12px;\n            }\n        }\n    }\n    .detailCard {\n        margin-top: 2%;\n        background: #ffffff;\n        border-radius: 16px;\n        padding: 24px;\n\n        .cardHeader {\n            display: flex;\n            .leftContainer {\n                text-align: left;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n            }\n            .rightContainer {\n                margin-left: auto;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                display: flex;\n            }\n        }\n\n        .tableContainer {\n            .nameCircle {\n                background: #c1c1c1;\n                width: 24px;\n                height: 24px;\n                border-radius: 12px;\n                color: white;\n                font-weight: 700;\n                font-size: 8px;\n                line-height: 16px;\n                text-align: center;\n                padding-top: 4px;\n                position: relative;\n            }\n\n            .nameText {\n                position: relative;\n                top: 3px;\n                padding-left: 10px;\n            }\n\n            .actionButton {\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 18px;\n                text-align: center;\n                color: #505054;\n                border: 1px solid #e1e1e1;\n                border-radius: 6px;\n                padding: 8px;\n                margin: auto;\n                background-color: white;\n            }\n\n            .disabledButton {\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 18px;\n                text-align: center;\n                color: #505054;\n                border-radius: 6px;\n                padding: 8px;\n                margin: auto;\n                background-color: white;\n                cursor: default;\n            }\n            .stateCellContainer {\n                display: flex;\n\n                flex-direction: row;\n                .stateIndicator {\n                    height: 6px;\n                    width: 6px;\n                    border-radius: 3px;\n                    margin-right: 10px;\n                    position: relative;\n                    top: 5px;\n                }\n\n                .probation {\n                    position: relative;\n                    margin-left: 10px;\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 700;\n                    font-size: 12px;\n                    color: #49ae9e;\n                    padding: 0 5px;\n                    background: #e5f4f2;\n                    border-radius: 50px;\n                    text-align: center;\n                }\n            }\n            .typeContainer {\n                display: inline-block;\n                padding: 2px 6px;\n                background: #f9e0da;\n                border-radius: 4px;\n                font-weight: 700;\n                font-size: 12px;\n                line-height: 18px;\n            }\n            .redType {\n                background-color: #f9e0da;\n                color: #874a3d;\n            }\n\n            .blueType {\n                background-color: #d5e5f3;\n                color: #385b7d;\n            }\n\n            .greenType {\n                background-color: #d6eed9;\n                color: #2b6132;\n            }\n\n            table {\n                border: none;\n                margin-top: 24px;\n                width: 100%;\n                border-collapse: collapse;\n            }\n            th {\n                .flexibleColumns {\n                    display: flex;\n                    flex-direction: row;\n                    padding-left: 50px; \n                }\n                .flexibleColumnsNotWorking {\n                    display: flex;\n                    flex-direction: row;\n                    padding-left: 25px; \n                }\n                border: none;\n                height: 48px;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                align-items: center;\n                color: #505054;\n                background: #f9fafb;\n                border-top: 1px solid black;\n                border-bottom: 1px solid #e9e9e9;\n\n                input {\n                    margin-right: 10px;\n                }\n            }\n            td {\n                height: 64px;\n                border-bottom: 1px solid #e9e9e9;\n                input {\n                    position: relative;\n                    margin-right: 10px;\n                }\n\n                .flexibleColumns {\n                    display: flex;\n                    flex-direction: row;\n                    padding-left: 50px;\n                }\n                .flexibleColumnsNotWorking {\n                    display: flex;\n                    flex-direction: row;\n                    padding-left: 25px; \n                }\n\n            }\n        }\n    }\n}\n\n.deleteContainer {\ndisplay: flex;\njustify-content: flex-end;\nmargin-top: 24px;\n\n    .delete{\n        border: 1px solid red;\n        color: red;\n        border-radius: 8px;\n        padding: 12px 48px;\n    }\n}\n.tooltip-row{\n    margin-bottom: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
